import { ListItemButton, ListItemText } from "@mui/material";
import type { Site } from "../../../types/Site";

interface SiteItemProps {
    site: Site;
    setSelectedSite: (site: Site) => void;
}

/**
 * SiteItem
 *
 * Renders a selectable list item for a given site. On click, sets the selected site using the provided setSelectedSite prop.
 *
 * @param {object} props
 * @param {Site} props.site - The site to display and select
 * @param {function} props.setSelectedSite - Function to set the selected site
 */
export const SiteItem = ({ site, setSelectedSite }: SiteItemProps) => {
    return (
        <ListItemButton
            sx={{ pl: 2, pt: 0, pb: 0 }}
            onClick={() => setSelectedSite(site)}
        >
            <ListItemText
                primary={site.displayName}
                slotProps={{
                    primary: {
                        style: {
                            color: "#013c4a",
                            fontWeight: "medium",
                            fontSize: 16,
                            whiteSpace: "nowrap",
                        },
                    },
                }}
                inset
            />
        </ListItemButton>
    );
};
